var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.project_id || _vm.loaded)?_c('project-form'):(_vm.error)?_c('error-view',{attrs:{"error":_vm.error},on:{"reload":_vm.load}}):_c('vpreloader',{attrs:{"width":"2","size":"64"}})
}
var staticRenderFns = []

export { render, staticRenderFns }